import React, { useContext, useEffect, useRef, useState } from 'react';
import './AdyenApplePay.less';
import { DrawerPopup } from '../../dialog-layout/drawer-popup/DrawerPopup';
import { getSafeTranslation } from '../../../helpers/localization.helper';
import { TranslationsContext } from '../../../contexts/translations-context';
import { IPaymentModel } from '../../../interfaces/adyen-payment.interface';
import Config from '../../../config';
import AdyenCheckout from '@adyen/adyen-web';
import ApplePayElement from '@adyen/adyen-web/dist/types/components/ApplePay';
interface AdyenApplePayType {
	adyenClientKey: string;
	adyenPaymentMethodsResponse: IPaymentModel;
    orderAmount: number;
    orderCurrency: string;
    adyenCountryCode: string;
    onSubmit: (state, dropin) => void;
    cancelApplePayPopup: () => void;
}

export const AdyenApplePay: React.FC<AdyenApplePayType> = (
	{
		adyenClientKey,
		adyenPaymentMethodsResponse,
        adyenCountryCode,
        orderAmount,
        orderCurrency,
        onSubmit,
        cancelApplePayPopup
	}
) => {

    const translations = useContext(TranslationsContext);
    const adyenApplePayRef = useRef<HTMLDivElement>(null);
    const [dropin, setDropin] = useState<ApplePayElement>(null);


    const applePayConfiguration = {
        amount: {
            value: orderAmount * 100,
            currency: orderCurrency
        },
        countryCode: adyenCountryCode
    };

    const configuration = {
        clientKey: adyenClientKey,
        locale: Config.adyenLocale,
        environment: Config.adyenEnvironment,
    };

    const checkout = new AdyenCheckout(configuration);

    useEffect(() => {
        if (!adyenClientKey || !adyenPaymentMethodsResponse) {
            return;
        }
        setDropin(checkout.create('applepay', {
           configuration: {
               merchantName: adyenPaymentMethodsResponse.paymentMethods[0]['configuration']['merchantName'],
               merchantId: adyenPaymentMethodsResponse.paymentMethods[0]['configuration']['merchantId'],
           },
            onSubmit,
           ...applePayConfiguration
        }).mount(adyenApplePayRef.current));
    }, [adyenClientKey, adyenPaymentMethodsResponse]);

    return (
		<DrawerPopup
			title={
				getSafeTranslation('AdyenApplePayPopup.title', translations)
			}
			onOverlayClick={cancelApplePayPopup}
		>
            <div className="adyen-apple-pay">
                <div ref={adyenApplePayRef} />
			</div>
		</DrawerPopup>
	);
}

